import * as React from 'react';
import ErrorMessage from './errorMessage';

const GenericErrorMessage: React.FunctionComponent = (): React.ReactElement => (
  <ErrorMessage title="Uh Oh...">
    There was a problem loading this page. Please refresh the page. If the problem persists contact{' '}
    <a href="mailto:support@sumzero.com">support@sumzero.com</a>.
  </ErrorMessage>
);

export default GenericErrorMessage;
